var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_658_6613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9516 39.7031C9.22563 39.7031 0.499999 30.9775 0.499998 20.2515C0.499997 9.52559 9.22563 0.799964 19.9516 0.799963C30.6775 0.799962 39.4032 9.52559 39.4032 20.2515C39.4032 30.9775 30.6775 39.7031 19.9516 39.7031ZM24.3395 13.2927C24.9733 12.659 24.9733 11.6345 24.3395 11.0007C24.0234 10.6846 23.6085 10.5258 23.1935 10.5258C22.7785 10.5258 22.3635 10.6846 22.0474 11.0007L13.9426 19.1055C13.3089 19.7393 13.3089 20.7637 13.9426 21.3975L22.0475 29.5024C22.6813 30.1361 23.7057 30.1361 24.3395 29.5024C24.9733 28.8686 24.9733 27.8441 24.3395 27.2103L17.3807 20.2515L24.3395 13.2927Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_658_6613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.9032,
    height: 38.9032,
    fill: "white",
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 0.5 39.7031)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.f4619a8a26f402b05cd267c9d38aeadb.svg";
export { ForwardRef as ReactComponent };